<script lang="ts">
  import { redirect, params } from "@sveltech/routify";
  import { appState } from "../../../lib/appState";

  console.log($appState.user);

  if ($appState.user?.company) {
    $redirect(`/business/offer/${$params.offerId}`, {
      action: "complete",
    });
  } else if ($appState.user?.charity) {
    $redirect(`/charity/offer/${$params.offerId}`, {
      action: "complete",
    });
  } else {
    $redirect("/");
  }
</script>
